import { useEffect } from "react"
import { DadosContainerDefault } from "../../components/Styles"
import Recompensas from "../../components/Recompensas/Recompensas"

function RecompensasPage() {
  useEffect(() => {
    document.title = "Recompensas | Gesttor"
  }, [])

  return (
    <DadosContainerDefault>
      <Recompensas />
    </DadosContainerDefault>
  )
}

export default RecompensasPage
